/**
 * Helper
 */
var helper = require('../../helper');
var AjaxController = require('./../../services/AjaxController');
require('jquery-ui');
require('jquery-ui/ui/widgets/sortable.js')

$(function() {
    var $datatable = $('#datatable-all-staff'),
    dt;

    dt = $datatable.DataTable({
        "dom": "<'dt-toolbar dt-toolbar-no-buttons'lf>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
	    "lengthMenu": [[ 50, 10, 25, 30, 75, 100], [ 50, 10, 25, 30, 75, 100]],
	    "ajax": {
		    "url": helper.getOrigin() + "/api/users/staff",
		    "method": 'POST',
		    "data": function ( d ) {
		    }
	    },
        "bAutoWidth" : false,
        "order": [[ 1, "asc" ]],
        "columns": [
            {data: 'order', name: 'order', orderable: false,  searchable: false},
	        {data: 'staff_order', name: 'staff_order'},
            {data: 'name', name: 'name'},
            {data: 'email', name: 'email'},
            {data: 'roleName', name: 'roleName'},
	        {data: 'departmentName', name: 'departmentName'},
	        {data: 'staff_guardian_page', name: 'staff_guardian_page'},
	        {data: 'staff_property_owners', name: 'staff_property_owners'},
	        {data: 'staff_about_us_page', name: 'staff_about_us_page'},
	        {data: 'userColor', name: 'userColor'},
	        {data: 'last_login', name: 'last_login'},
            {data: 'created_at', name: 'created_at'},
            {
                data: 'actions',
                name: 'actions',
                orderable: false,
                searchable: false,
                className : "action"
            }
        ],
	    "createdRow": function (row, data, rowIndex) {
		    $(row).attr('data-id', data.userId);
		    $(row).find('td:first').addClass('sortable-handle-staff cursor-move centerize');
	    },
    });

	$('.js-users-activity-box').on('click', function() {
		var $this = $(this),
				$clickedStaff = $('input[name="clickedStaff"]'),
				staff = $(this).data('staff');

		$clickedStaff.val(staff);

		dt.ajax.reload();
	});

	$( "#sortable-staff" ).sortable({
		axis: 'y',
		handle: 'td:first',
		start: function(event, ui) {
			var start_pos = ui.item.index();
			ui.item.data('start_pos', start_pos);
		},
		update: function (event, ui) {
			var url = "/api/users/staff/sort";
			var order = [];

			$('#sortable-staff tr').each( function(e) {
				var obj = new Object();
				obj.userId =  $(this).attr('data-id');
				obj.position =  $(this).index()+1;

				order.push( JSON.stringify(obj) );
			});

			var data = {
				'order': order,
			}

			var success = function (response) {
				dt.ajax.reload();
			}

			var error = function (response) {
				console.log('Error');
			}

			AjaxController.prototype.send(url, data, success, error);
		}
	});

});
